var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_1312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2792 7.33917L16.0542 5.16083L11.25 7.8625V2.5H8.74999V7.8625L3.94583 5.16083L2.72083 7.33917L7.45082 10L2.72083 12.6608L3.94583 14.8392L8.74999 12.1375V17.5H11.25V12.1375L16.0542 14.8392L17.2792 12.6608L12.5492 10L17.2792 7.33917Z",
    fill: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.16665C10.9205 4.16665 11.6667 3.42045 11.6667 2.49998C11.6667 1.57951 10.9205 0.833313 10 0.833313C9.07954 0.833313 8.33334 1.57951 8.33334 2.49998C8.33334 3.42045 9.07954 4.16665 10 4.16665Z",
    fill: "url(#paint0_linear_68_1312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 7.91665C17.5871 7.91665 18.3333 7.17045 18.3333 6.24998C18.3333 5.32951 17.5871 4.58331 16.6667 4.58331C15.7462 4.58331 15 5.32951 15 6.24998C15 7.17045 15.7462 7.91665 16.6667 7.91665Z",
    fill: "url(#paint1_linear_68_1312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33332 7.91665C4.2538 7.91665 4.99999 7.17045 4.99999 6.24998C4.99999 5.32951 4.2538 4.58331 3.33332 4.58331C2.41285 4.58331 1.66666 5.32951 1.66666 6.24998C1.66666 7.17045 2.41285 7.91665 3.33332 7.91665Z",
    fill: "url(#paint2_linear_68_1312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19.1666C10.9205 19.1666 11.6667 18.4205 11.6667 17.5C11.6667 16.5795 10.9205 15.8333 10 15.8333C9.07954 15.8333 8.33334 16.5795 8.33334 17.5C8.33334 18.4205 9.07954 19.1666 10 19.1666Z",
    fill: "url(#paint3_linear_68_1312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33332 15.4166C4.2538 15.4166 4.99999 14.6705 4.99999 13.75C4.99999 12.8295 4.2538 12.0833 3.33332 12.0833C2.41285 12.0833 1.66666 12.8295 1.66666 13.75C1.66666 14.6705 2.41285 15.4166 3.33332 15.4166Z",
    fill: "url(#paint4_linear_68_1312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 15.4166C17.5871 15.4166 18.3333 14.6705 18.3333 13.75C18.3333 12.8295 17.5871 12.0833 16.6667 12.0833C15.7462 12.0833 15 12.8295 15 13.75C15 14.6705 15.7462 15.4166 16.6667 15.4166Z",
    fill: "url(#paint5_linear_68_1312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    fill: "url(#paint6_linear_68_1312)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_1312",
    x1: 10,
    y1: 0.833313,
    x2: 10,
    y2: 4.16665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_1312",
    x1: 16.6667,
    y1: 4.58331,
    x2: 16.6667,
    y2: 7.91665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_68_1312",
    x1: 3.33332,
    y1: 4.58331,
    x2: 3.33332,
    y2: 7.91665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_68_1312",
    x1: 10,
    y1: 15.8333,
    x2: 10,
    y2: 19.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_68_1312",
    x1: 3.33332,
    y1: 12.0833,
    x2: 3.33332,
    y2: 15.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_68_1312",
    x1: 16.6667,
    y1: 12.0833,
    x2: 16.6667,
    y2: 15.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_68_1312",
    x1: 10,
    y1: 7.5,
    x2: 10,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_1312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkHover);
export default __webpack_public_path__ + "static/media/network-hover.687d934a413f8498eecc11498e9adbe9.svg";
export { ForwardRef as ReactComponent };